import React from 'react'
import { Grid, Box, OutlinedInput } from '@mui/material'
import { PartialAction, Personal, Position } from 'src/types'
import { useDebounce } from 'use-debounce'
import Select from 'react-select'
import { UseFormRegister } from 'react-hook-form'
import { useLocale } from 'src/locales/useLocale'
export const SET_PERSONAL = 'setPersonal'

type Props = {
  position: Position
  isDisabled: boolean
  duplicationPosition?: boolean
  existEmoji: boolean
  existArribaFontNoPointColor: boolean
  dispatch: React.Dispatch<PartialAction>
  register: UseFormRegister<{ mailAddress: string; mailAddress2: string }>
}

export const ConsumerForm: React.FC<Props> = ({
  position,
  isDisabled,
  duplicationPosition,
  existEmoji,
  existArribaFontNoPointColor,
  dispatch,
  register
}) => {
  const [personalData, setPersonalData] = React.useState<Personal>()
  const personal = useDebounce(personalData, 500)
  const { t } = useLocale()
  React.useEffect(() => {
    dispatch({ type: SET_PERSONAL, personal: personal[0] })
  }, [personal[0]])

  const positionOptions = t.POSITION_OPTIONS.filter((option) => option.attribute === position).map((option) => ({
    label: option.label,
    value: option.value
  }))

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box pt={2} mr={1} display={'flex'} alignItems={'center'}>
          <Box fontWeight="bold" fontSize="16px" mb={1}>
            {t.CUSTOMER_INFORMATION}
          </Box>
        </Box>
        {existEmoji && <Box color={'red'}>絵文字を刺繍内容から排除してください。</Box>}
        {isDisabled && <Box color={'red'}>{t.CUSTOMER_INFORMATION_CAUTION}</Box>}
        {duplicationPosition && <Box color={'red'}>{t.DUPLICATE_EMBROIDERY_POSITION_CAUTION}</Box>}
        {existArribaFontNoPointColor && <Box color={'red'}> 刺繍におけるアリーバ体のポイントカラーを指定してください。</Box>}
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Box p={1}>
              <Box>{t.LEAGUE}</Box>
              <Select
                options={t.LEAGUE_OPTIONS}
                styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                isDisabled={isDisabled}
                isSearchable={false}
                menuPlacement={'top'}
                onChange={(value) => setPersonalData({ ...personalData, league: value.label })}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box p={1}>
              <Box>{t.FIELD_POSITION}</Box>
              <Select
                styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                options={positionOptions}
                // defaultValue={(isPitcher || isMitt) && positionOptions[0]}
                isMulti
                isSearchable={false}
                isDisabled={isDisabled}
                menuPlacement={'top'}
                onChange={(values) =>
                  setPersonalData({
                    ...personalData,
                    position: values.map((value) => value.label)
                  })
                }
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box p={1}>
              <Box>{t.EMAIL_ADDRESS}</Box>
              <Box pb={1} display={'flex'} alignItems={'center'}>
                <OutlinedInput type={'email'} autoComplete={'off'} fullWidth {...register('mailAddress')} disabled={isDisabled} />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box p={1}>
              <Box>{t.EMAIL_ADDRESS_RETYPE}</Box>
              <Box pb={1} display={'flex'} alignItems={'center'}>
                <OutlinedInput type={'email'} autoComplete={'off'} fullWidth {...register('mailAddress2')} disabled={isDisabled} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
